module.exports = __webpack_public_path__ + "static/img/tu.5c9cfdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tu.png
// module id = ztwJ
// module chunks = 1